var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-additional-services additional-services"},[_c('Headline',{attrs:{"value":_vm.headline,"number":("" + (_vm.data.sectionNumber))}}),_vm._v(" "),(_vm.offer)?_c('div',{staticClass:"additional-services--row"},_vm._l((_vm.services),function(service){return _c('Service',{key:service.Code,attrs:{"value":service,"offer":_vm.offer}})}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e10f8b6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/AdditionalServices.vue
// module id = 971
// module chunks = 1